import React from 'react';
import { getSupportEmailByRegion } from '../../i18n/utils';
import { getPlatformRegion } from '../../utils';

type ErrorContentProps = {
  label?: React.ReactNode;
};

/**
 * Renders the content for displaying an error message.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.label - The error message label. Can be a string or a React node component.
 * @returns {JSX.Element} The rendered error content.
 */
export const ErrorContent = ({
  label = 'Uh oh! It appears a system error has occurred and selected operation can not be performed at this time.',
}: ErrorContentProps) => {
  const email = getSupportEmailByRegion(getPlatformRegion());

  return (
    <>
      <div
        style={{
          padding: '0.5rem',
        }}
      >
        {label}
      </div>
      Please try again later. If the issue persists please contact{' '}
      <a style={{ textDecoration: 'underline' }} href={`mailto:${email}`}>
        Cowbell Support
      </a>{' '}
      for assistance.
    </>
  );
};
